import React from 'react';

import C from '../C';
import Roles from '../base/Roles';
import Misc from '../base/components/Misc';
import ActionMan from '../plumbing/ActionMan';
import DataStore from '../base/plumbing/DataStore';
import ServerIO from '../plumbing/ServerIO';
import CardAccordion, { Card } from '../base/components/CardAccordion';
import PropControl from '../base/components/PropControl';


function SystemPage() {
	// // ??test does editing work? or do we have to manage draft vs published here??
	// const globalPath = getPath(C.KStatus.PUBLISHED, C.TYPES.Global, 'global');

	// // Wrap updateFromServer to specify PUBLISHED status because Global obj has no status
	// const globalPv = DataStore.fetch(globalPath, () => (
	// 	ServerIO.search(C.TYPES.Global)
	// 		.then((response) => response.cargo && response.cargo.hits && response.cargo.hits[0])
	// ));
	// if ( ! globalPv.resolved) return <Misc.Loading />;
	// const global = globalPv.value;
	const blocked = Misc.CheckAccess({can: 'admin'});
	if (blocked) return blocked;

	return (
		<div className="SystemPage">
			<h2 className="alert alert-warning">Good-Loop Whole System Settings</h2>

			<p>TODO think about anything that ends up here</p>

			<CardAccordion>
				<Card title="Poke DataLog">
					<PokeDataLog />
				</Card>
			</CardAccordion>

		</div>
	);
}


function PokeDataLog() {
	if (!Roles.isDev()) return null;

	let path = ['widget', 'PokeDataLog', 'JournalEntry'];
	let pathe = path.concat('e');
	// Most settings go into the props map for a DatalogEvent JournalEntry.e. See JournalEntry.java
	let pathprops = pathe.concat('props');
	let pokebase = {
		makeEvent: true,
		e: {props: {via: 'portal'}}
	};
	let poke = DataStore.getValue(path) || DataStore.setValue(path, pokebase, false);
	if (!poke.e) poke.e = {};
	let pokeProps = poke.e.props || {};
	const pvPokes = ActionMan.list({type:C.TYPES.JournalEntry, status:C.KStatus.ALL_BAR_TRASH});

	let spendq = `vert:${pokeProps.vert} pub:${pokeProps.pub} campaign:${pokeProps.campaign} cid:${pokeProps.cid}`;
	let pvSpendData = DataStore.fetch(['widget','PokeDataLog','spend', spendq],
		() => ServerIO.getSpendData({q:spendq})
	);
	let pvDonData = DataStore.fetch(['widget','PokeDataLog','don', spendq],
		() => ServerIO.getDonationsData({q:spendq})
	);
	let pvAllSpend = pokeProps.vert ? DataStore.fetch(['widget','PokeDataLog','BudgetSpend', pokeProps.vert],
		() => ServerIO.getAllSpend({vert:pokeProps.vert})
	) : {};

	return (<div>
		<p>This tool lets you manually poke missing campaign data into the system.
		It is for activity that wasn&#39;t recorded by our usual logging.</p>
	
		<PropControl prop="eventType" label="Event" path={pathe} type="select"
			options={['render','visible','open','minview','click','spend','spendadjust','adhoc']}
		/>
		<div>{/* show desc from TrafficReport */}</div>
		<PropControl prop="count" label="Count" path={pathe} type="number" />

		<PropControl prop="pricePerCount" label="Price _per event_" path={path} type="Money" />
		<div>Total poke: <Misc.Money amount={poke.pricePerCount * poke.e.count} /></div>

		<PropControl prop="pub" label="Publisher" path={pathprops} />
		<PropControl prop="campaign" label="Advert Campaign" path={pathprops} />
		<PropControl prop="vert" label="Advert ID" path={pathprops} type="autocomplete"
			getItemValue={item => item.id}
			renderItem={(item, isHighlighted) => {
				return (
					<div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
						{item.id} - {item.name}
					</div>
				);
			}}
			options={Object.values(DataStore.getValue('data','Advert') || {})}
		/>
		<PropControl prop="cid" label="Charity ID" path={pathprops}
			help="If blank, unallocated spends will get auto-allocated via spendadjusts"
		/>
		<PropControl prop="via" label="Via" path={pathprops} />

		<PropControl prop="makeEvent" type="checkbox" label="Create an event in DataLog" path={path} />
		<PropControl prop="makeBid" type="checkbox" label="Create a Bid" path={path} />
		<PropControl prop="modifyBudget" type="checkbox" label="Modify advert budget" path={path}
			help="Budgets are linked to an Advert campaign" disabled={ ! DataStore.getValue(pathprops.concat('campaign'))}
		/>

		<Misc.SubmitButton path={path} url="/journal?action=publish" once>Submit Data-Journal Entry</Misc.SubmitButton>

		<h5>Stats</h5>
		Spend
		{JSON.stringify(pvSpendData.value)}
		
		All Spend for {pokeProps.vert}
		{JSON.stringify(pvAllSpend.value)}
		
		<div>
			Donations
			{JSON.stringify(pvDonData.value)}
		</div>
		
		minviews for this pub/vert
		clicks

		<h5>List of Data-Journal Pokes</h5>
		{pvPokes.value && pvPokes.value.hits?
			pvPokes.value.hits.map(pk => <div className="well">{JSON.stringify(pk)}</div>)
			: <Misc.Loading />
		}
	</div>);
}

export default SystemPage;
